import type { RecordingVisibility } from '../components/practice/types';

export const RECORDING_VISIBILITY_OPTIONS: {
  value: RecordingVisibility;
  label: string;
  help: string;
}[] = [
  {
    value: 'rep_only',
    label: 'Only me',
    help: 'Only the rep and people in the session can read the transcript and feedback.',
  },
  {
    value: 'rep_and_managers',
    label: 'Me and managers',
    help: 'Owners, admins, and managers can also read the transcript and feedback.',
  },
  {
    value: 'named_viewers',
    label: 'Me and people I choose',
    help: 'Only teammates the rep picks can also read the transcript and feedback.',
  },
];

export const SCORES_ALWAYS_VISIBLE_NOTE =
  'Scores and session details are always visible to managers.';

export const RECORDING_PRIVATE_MESSAGE =
  "The rep has kept this session's transcript and feedback private.";

export function isRecordingVisibility(value: unknown): value is RecordingVisibility {
  return RECORDING_VISIBILITY_OPTIONS.some((o) => o.value === value);
}

/** True when moving from `from` to `to` lets someone new read the transcript. */
export function widensRecordingAccess(
  from: { level: RecordingVisibility; viewerIds: readonly string[] },
  to: { level: RecordingVisibility; viewerIds: readonly string[] },
): boolean {
  if (to.level === 'rep_only') return false;
  if (to.level !== from.level) return true;
  if (to.level === 'named_viewers') {
    const before = new Set(from.viewerIds);
    return to.viewerIds.some((id) => !before.has(id));
  }
  return false;
}
